<template>
    <div class="header">
        <div class="header-image-container">
            <router-link :to="`/${currentLanguage}`" class="header-text" @click="() => logMessage('info', 'Header_Home')">Apartmány Danka</router-link>
            <div class="burger-menu" @click="toggleMenu">
                <div class="burger-line"></div>
                <div class="burger-line"></div>
                <div class="burger-line"></div>
            </div>
        </div>
        <NavMenu ref="navMenu" :is-menu-open="isMenuOpen" @update:is-menu-open="updateMenuState"/>
    </div>
</template>

<script>
import NavMenu from './nav-menu/nav-menu.vue';
import { logMessage } from '../../utils/flaskapi';
export default {
    name: 'Header',
    components: {
        NavMenu
    },
    data() {
        return {
            currentLanguage: 'en',
            isMenuOpen: false
        }
    },
    methods: {
        logMessage,
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
            // Prevent scrolling when menu is open
            document.body.style.overflow = this.isMenuOpen ? 'hidden' : '';
        },
        closeMenu() {
            if (this.isMenuOpen) {
                this.isMenuOpen = false;
                document.body.style.overflow = '';
            }
        },
        updateMenuState(newState) {
            this.isMenuOpen = newState;
            document.body.style.overflow = newState ? 'hidden' : '';
        }
    },
    created() {
        // Set initial language based on route
        const lang = localStorage.getItem("preferredLanguage") || 'sk';
        this.currentLanguage = lang;
        this.$i18n.locale = lang;

        // Add click outside listener
        this.handleClickOutside = (event) => {
            const nav = document.querySelector('.nav-links');
            const burger = document.querySelector('.burger-menu');
            if (nav && burger && !nav.contains(event.target) && !burger.contains(event.target)) {
                this.closeMenu();
            }
        };
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    watch: {
        '$route': {
            immediate: true,
            handler(newRoute) {
                const lang = newRoute.path.split('/')[1] || 'en';
                if (this.currentLanguage !== lang) {
                    this.currentLanguage = lang;
                    this.$i18n.locale = lang;
                }
            }
        }
    }
}
</script>

<style>
@import './header_style.css';
</style>